// Mirrors _features/billingUnits/state/slice.js's shape (selectedFilters
// only, REHYDRATE normalization) - does NOT carry forward the old tree's
// (since fully retired) equivalent slice's `systemFeatures` array mirror
// (write-only dead-sync - nothing ever read state.systemFeature.systemFeatures;
// useSystemFeatureData already returns straight from the RTK Query cache)
// or its `customColumns` (also write-only - the filters hook reads columns
// from local useState, not the slice).
//
// Key renamed from the old bare "systemFeature" (the only migrated
// feature's slice this session not following the <name>Feature suffix
// convention every sibling slice uses) to "systemFeaturesFeature" for
// consistency - safe because only selectedFilters survives and
// zero cross-feature code reads state.systemFeature.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const systemFeaturesFeatureSlice = createSlice({
  name: "systemFeaturesFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.systemFeaturesFeature) {
        const persistedData = action.payload.systemFeaturesFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = systemFeaturesFeatureSlice.actions;

export default systemFeaturesFeatureSlice.reducer;
